import FlexRow from "Components/FlexRow";
import Box from "Components/Box";
import ResetPasswordForm from "Features/Authentication/Components/ResetPasswordForm";
import AnotherSolutionIcon from "../Assets/SVG/AnotherSolutionIcon";

const ResetPassword = () => {
    
    return (
        <FlexRow className={"h-100"} justify={"center"} align={"center"}>
            <div style={{width: 400}}>
                <Box>
                    <AnotherSolutionIcon width={200} style={{paddingBottom: 20}} />
                    <ResetPasswordForm />
                </Box>
            </div>
        </FlexRow>
    )
}

export default ResetPassword
